import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const CGV = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 pt-28 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          <header className="space-y-4 text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Conditions Générales de Vente (CGV)</h1>
            <p className="text-gray-600 text-lg">Version indicative – à valider / adapter selon ton activité.</p>
          </header>

          <section className="space-y-6 text-gray-700 leading-relaxed">
            <h2 className="text-2xl font-semibold text-gray-900">1. Objet</h2>
            <p>
              Les présentes CGV encadrent les prestations de conseil, accompagnement chantier, étude et suivi proposées par CTB28 (le « Prestataire ») auprès de ses clients (le « Client »).
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">2. Prestations</h2>
            <p>
              Les prestations sont précisées dans le devis ou la proposition : étude de faisabilité, lecture de devis, conseil travaux, suivi de chantier, conseil matériaux, etc. Toute demande hors périmètre initial fera l'objet d'un avenant ou d'une nouvelle proposition.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">3. Devis & acceptation</h2>
            <p>
              Le devis émis a une durée de validité (par défaut 30 jours). L'acceptation se matérialise par signature ou validation électronique. Toute modification ultérieure peut modifier délais et tarifs.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">4. Tarification & paiement</h2>
            <p>
              Les tarifs peuvent être forfaitaires ou calculés au temps passé. Les modalités (acompte, échéancier, solde) sont précisées sur le devis. Les retards de paiement peuvent entraîner des pénalités légales.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">5. Obligations du Client</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>Fournir des informations exactes et complètes.</li>
              <li>Faciliter l'accès au site ou aux documents nécessaires.</li>
              <li>Régler les factures selon l'échéancier convenu.</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900">6. Limites d'intervention</h2>
            <p>
              Le Prestataire intervient en conseil / coordination. Il n'exécute pas directement les travaux. La responsabilité d'exécution reste aux entreprises tierces sélectionnées par le Client ou recommandées.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">7. Assurance & responsabilité</h2>
            <p>
              Le Prestataire agit avec diligence. Sa responsabilité ne saurait être engagée pour les défauts d'exécution des entreprises tierces, ni en cas de force majeure. Le Client conserve ses responsabilités légales en tant que maître d'ouvrage.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">8. Confidentialité</h2>
            <p>
              Les informations échangées sont confidentielles. Le Prestataire s'engage à ne pas divulguer d'informations sensibles sans accord préalable, sauf obligation légale.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">9. Données personnelles</h2>
            <p>
              Le traitement des données personnelles est décrit dans la <a href="/politique-confidentialite" target="_blank" rel="noopener noreferrer" className="text-blue-900 underline">Politique de confidentialité</a>.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">10. Résiliation</h2>
            <p>
              Toute résiliation anticipée doit être confirmée par écrit. Les prestations réalisées restent dues. Un dédommagement peut s'appliquer si des ressources ont été bloquées.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">11. Litiges</h2>
            <p>
              En cas de litige, une résolution amiable sera recherchée. À défaut, compétence attribuée aux tribunaux du ressort du siège du Prestataire.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900">12. Acceptation</h2>
            <p>
              Le Client reconnaît avoir pris connaissance des présentes CGV et les accepter sans réserve avant toute commande de prestation.
            </p>

            <p className="text-sm text-gray-500">Texte à adapter définitivement (mentions légales commerciales, numéro SIRET, assurances, pénalités…)</p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CGV;
